import { render, staticRenderFns } from "./AssignedCompetencyDetail.vue?vue&type=template&id=293b8f0c&scoped=true"
import script from "./AssignedCompetencyDetail.vue?vue&type=script&lang=js"
export * from "./AssignedCompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./AssignedCompetencyDetail.vue?vue&type=style&index=0&id=293b8f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293b8f0c",
  null
  
)

export default component.exports